/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Refineexampleremoveobjects3Inputs */

const en_refineexampleremoveobjects3 = /** @type {(inputs: Refineexampleremoveobjects3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove objects`)
};

const de_refineexampleremoveobjects3 = /** @type {(inputs: Refineexampleremoveobjects3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objekte entfernen`)
};

/**
* | output |
* | --- |
* | "Remove objects" |
*
* @param {Refineexampleremoveobjects3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const refineexampleremoveobjects3 = /** @type {((inputs?: Refineexampleremoveobjects3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refineexampleremoveobjects3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_refineexampleremoveobjects3(inputs)
	return de_refineexampleremoveobjects3(inputs)
});
export { refineexampleremoveobjects3 as "refineExampleRemoveObjects" }